<template>
  <loading v-if="loading" />
  <error-messages
    v-else-if="!loading && errorMessagesGetList.length > 0"
    :show="true"
    :messages="errorMessagesGetList"
  />
  <empty-list
    v-else-if="
      !loading && errorMessagesGetList.length === 0 && items.length === 0
    "
    :srcImage="require('@/assets/images/fileManager-empty.png')"
    btnText="راه‌اندازی مدیریت فایل"
    :loadingBtn="true"
    :loading="loadingCreate"
    :disabled="loadingCreate"
    @btnCreateClicked="createAccounts"
  >
    <template v-slot:messages>
      <error-messages
        v-if="errorMessagesCreate.length > 0"
        :show="showErrorCreate"
        :messages="errorMessagesCreate"
        :dismissible="true"
        @dismissed="createDismissed"
      />
      <p>
        <strong>از این طریق می‌توانید برای مدیریت فایل خود اقدام کنید.</strong>
      </p>
      <p class="empty-layout-note">
        <span>نکته:</span>
        بعد از ایجاد مدیریت فایل دو حساب با نقش‌های Admin و User در اختیار شما
        قرار می‌گیرد.
      </p>
      <p class="empty-layout-note">
        <span>نکته:</span>
        نقش Admin دارای دسترسی کامل است و نقش User فقط دارای دسترسی خواندنی است.
      </p>
    </template>
  </empty-list>
  <main-page-service
    v-else
    title="لیست حساب‌های مدیریت فایل"
    btnText="حذف آیتم"
    @btnCreateClicked="showDeleteModal"
  >
    <b-table
      caption-top
      responsive
      hover
      :items="items"
      :fields="fields"
      table-class="table-list-table"
      thead-tr-class="table-list-thead-tr"
      tbody-tr-class="table-list-tbody-tr"
    >
      <template #table-caption>
        <b-link :href="filemangerUrl" target="_black">
          {{ filemangerUrl }}
        </b-link>
      </template>
      <template #cell(isReadOnly)="data">
        <span v-if="data.item.isReadOnly">خواندنی</span>
        <span v-else>دسترسی کامل</span>
      </template>
    </b-table>
    <delete-file-manager-modal
      :visible="visibleDeleteModal"
      @hidden="hiddenDeleteModal"
      @deleteSuccess="getListAccounts"
    />
  </main-page-service>
</template>

<script>
import MainPageService from "@/components/MainPageService/MainPageService.vue";
import Loading from "@/components/Loading/Loading.vue";
import EmptyList from "@/components/EmptyList/EmptyList.vue";
import { fileMangerUserList, createFileManager } from "@/services/service";
import DeleteFileManagerModal from "./DeleteFileManagerModal.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";

export default {
  name: "AppFileManager",
  components: {
    EmptyList,
    Loading,
    MainPageService,
    DeleteFileManagerModal,
    ErrorMessages
  },
  data() {
    return {
      loading: false,
      filemangerUrl: "",
      errorMessagesGetList: [],
      items: [],
      fields: [
        {
          key: "username",
          label: "نام کاربری",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "password",
          label: "رمز عبور",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "isReadOnly",
          label: "نوع کاربر",
          thClass: "text-center",
          tdClass: "text-center"
        }
      ],
      // create data
      loadingCreate: false,
      errorMessagesCreate: [],
      showErrorCreate: false,
      // delete modal data
      visibleDeleteModal: false
    };
  },
  mounted() {
    this.getListAccounts();
  },
  methods: {
    getListAccounts: async function() {
      this.loading = true;
      const [error, data] = await fileMangerUserList(
        this.$route.params.serviceId
      );
      if (error) {
        this.errorMessagesGetList = error;
        this.loading = false;
      } else {
        if (data.apiStatus === 200) {
          this.items = [...data.apiData.bridges];
          this.filemangerUrl = `http://${data.apiData.serviceName}.cv9.ir/filemanager`;
          this.loading = false;
        } else {
          this.errorMessagesGetList = data.apiErrors;
          this.loading = false;
        }
      }
    },
    // create modal method
    createAccounts: async function() {
      this.loadingCreate = true;
      const [error, data] = await createFileManager({
        ServiceId: this.$route.params.serviceId
      });
      if (error) {
        this.errorMessagesCreate = error;
        this.showErrorCreate = true;
        this.loadingCreate = false;
      } else {
        if (data.apiStatus === 200) {
          this.getListAccounts();
          this.loadingCreate = false;
        } else {
          this.errorMessagesCreate = data.apiErrors;
          this.showErrorCreate = true;
          this.loadingCreate = false;
        }
      }
    },
    createDismissed: function() {
      this.showErrorCreate = false;
    },
    // delete modal method
    showDeleteModal: function() {
      this.visibleDeleteModal = true;
    },
    hiddenDeleteModal: function() {
      this.visibleDeleteModal = false;
    }
  }
};
</script>

<style lang="scss">
.empty-layout {
  width: 80%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 30px;

  &-note {
    border-bottom: 1px solid #ffc107;

    span {
      color: #ffc107;
      font-weight: 600;
    }
  }

  img {
    width: 60%;
    margin-bottom: 10px;
  }
}
</style>
